import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';

import CardButton from './CardButton';
import InvoicingButton from './InvoicingButton';
import MoreButtonV2 from './MoreButtonV2';
import MoveMoneyButton from './MoveMoneyButton';
import StatementButton from './StatementsButton';

export default function NavigationButtonsV2() {
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap="8px"
      mt={{ xs: '16px', md: '24px' }}
    >
      <Box
        display="flex"
        flexGrow={1}
      >
        <MoveMoneyButton />
      </Box>
      <InvoicingButton />
      <Box display={{ xs: 'none', sm: 'flex' }}>
        <CardButton />
      </Box>
      <Box display={{ xs: 'none', xl: 'flex' }}>
        <StatementButton />
      </Box>
      <MoreButtonV2 />
    </Stack>
  );
}
